import { Component, OnInit, Input, SimpleChanges} from '@angular/core';

@Component({
  selector: 'app-chip',
  templateUrl: './chip.component.html',
  styleUrls: ['./chip.component.scss']
})
export class ChipComponent implements OnInit {
  @Input() entityType: string;

  chipClass: string;
  label: string;
  constructor() { }

  setColor(className): void {
    this.chipClass = 'chip chip-' + className;
  }
  // Person, Location, Phone, E-mail
  setColors() {
    if (this.entityType === 'person') {
      this.setColor('blue');
      this.label = 'Person';
    } else if (this.entityType === 'location') {
      this.setColor('green');
      this.label = 'Location';
    } else if (this.entityType === 'phone') {
      this.setColor('red');
      this.label = 'Phone';
    // } else if (this.entityType === 'organization') {
    //   this.setColor('red');
    //   this.label = 'Organization';
    } else if (this.entityType === 'e-mail') {
      this.setColor('purple');
      this.label = 'E-mail';
    }
  }

  ngOnInit(): void {
    this.setColors();
  }

  ngOnChanges(changes: SimpleChanges) {
    this.setColors();
  }

}

